<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Dashboard</h1>
    <text-input v-model="form.dtProspeccao" type="date" value-type="YYYY-MM-DD" range class="w-full max-w-md mr-4" label="Período de" />
    <div class="mt-4">
      <div class="flex flex-wrap -mx-6 space-y-2 lg:space-y-0">
        <div class="w-full px-6 sm:w-1/2 xl:w-1/3">
          <div class="flex flex-col px-5 py-6 shadow-sm rounded-md bg-white">
            <span class="text-gray-600">PROSPECÇÕES </span>
            <div class="text-2xl text-indigo-600 py-2">{{ results.qtdProspeccoes }}</div>
            <h4 class="font-semibold text-gray-700">REALIZADAS</h4>
          </div>
        </div>

        <div class="w-full px-6 sm:w-1/2 xl:w-1/3">
          <div class="flex flex-col px-5 py-6 shadow-sm rounded-md bg-white">
            <span class="text-gray-600">MÉDIO DE PROSPECÇÕES</span>
            <div class="text-2xl text-indigo-600 py-2">{{ formatValue(results.mediaPorDia, 2) }} </div>
            <h4 class="font-semibold text-gray-700"> POR DIA</h4>
          </div>
        </div>

        <div class="w-full px-6 sm:w-1/2 xl:w-1/3 ">
          <div class="flex flex-col px-5 py-6 shadow-sm rounded-md bg-white">
            <span class="text-gray-600"> PROSPECÇÕES </span>
            <div class="text-2xl text-indigo-600 py-2"> {{ results.qtdProspeccoesFinalizada }} </div>
            <h4 class="font-semibold text-gray-700">FINALIZADAS</h4>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-4">
      <div class="flex flex-wrap  space-y-2 lg:space-y-0  ">
        <div class="w-full px-6 sm:w-full xl:w-2/3 bg-white shadow-sm rounded-md ">
          <div class="flex flex-col px-5 py-6 ">
            <span class="text-gray-600 font-bold">REAÇÕES DOS CLIENTES</span>
            <span class="text-gray-600 text-xs py-2" />
            <div class="py-2" />
            <reactions-chart :data="chartReacoes.data" />
          </div>
        </div>
        <div class="w-full pl-0 lg:pl-6   sm:w-full xl:w-1/3 min-h-full">
          <div class="flex flex-col px-5 py-6 shadow-sm rounded-md bg-white h-full">
            <span class="text-gray-600 font-bold">VENDEDORES</span>
            <span class="text-gray-600 text-xs py-2">PROSPECÇÕES POR VENDEDOR</span>
            <div class="py-2" />
            <div v-for="rank in results.topVendedores" :key="rank.razaoSocial" class="flex flex-row justify-between py-2">
              <span :title="rank.razaoSocial">{{ abrevia(rank.razaoSocial) }}</span>
              <span>{{ rank.qtde }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-4">
      <div class="flex flex-wrap  space-y-2 lg:space-y-0 ">
        <div class="px-6 w-full bg-white shadow-sm rounded-md overflow-x-auto">
          <div class="flex flex-col px-5 py-6 ">
            <span class="text-gray-600 font-bold">VISITAS PRÓXIMA SEMANA</span>
            <span class="text-gray-600 text-xs py-2" />
            <table class="w-full whitespace-nowrap">
              <tr class="text-left font-bold">
                <th class="px-6 pt-6 pb-4">ID</th>
                <th class="px-6 pt-6 pb-4">Nome</th>
                <th class="px-6 pt-6 pb-4">Dt. Prospecção</th>
                <th class="px-6 pt-6 pb-4">Dt. Visita</th>
              </tr>
              <tr v-for="cliente in results.visitasProximaSemana" :key="cliente.idProspeccao" class="hover:bg-gray-100 focus-within:bg-gray-100">
                <td class="border-t">
                  <inertia-link :href="route('prospeccoes.edit',cliente.idProspeccao )" class="px-6 py-4 flex items-center focus:text-indigo-500">
                    {{ cliente.idProspeccao }}
                  </inertia-link>
                </td>
                <td class="border-t">
                  <inertia-link :href="route('prospeccoes.edit',cliente.idProspeccao )" class="px-6 py-4 flex items-center focus:text-indigo-500">
                    {{ cliente.nome }}
                  </inertia-link>
                </td>

                <td class="border-t">
                  <inertia-link :href="route('prospeccoes.edit',cliente.idProspeccao )" class="px-6 py-4 flex items-center focus:text-indigo-500">
                    {{ dtProspeccao(cliente) }}
                  </inertia-link>
                </td>
                <td class="border-t">
                  <inertia-link :href="route('prospeccoes.edit',cliente.idProspeccao )" class="px-6 py-4 flex items-center focus:text-indigo-500">
                    {{ dtVisita(cliente) }}
                  </inertia-link>
                </td>

                <td class="border-t w-px">
                  <inertia-link :href="route('prospeccoes.edit',cliente.idProspeccao )" class="px-4 flex items-center" tabindex="-1">
                    <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
                  </inertia-link>
                </td>
              </tr>
              <tr v-if="results.visitasProximaSemana.length === 0">
                <td class="border-t px-6 py-4" colspan="4">Nenhum prospecção Encontrado.</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '../../Shared/TextInput.vue'
import debounce from 'lodash/debounce'
import pickBy from 'lodash/pickBy'
import { reacoes } from '@/Utils/helpers'
import ReactionsChart from '@/Shared/Charts/ReactionsChart.vue'
import { DateTime } from 'luxon'
import Icon from '../../Shared/Icon.vue'
export default {
  components: { TextInput, ReactionsChart, Icon },
  metaInfo: { title: 'Dashboard' },
  layout: Layout,
  props: {
    filters: Object,
    results: Object,
  },
  data() {
    return {
      chartReacoes: {
        data:{
          labels: this.results.reacoes.map(row => reacoes[row.reacao] || '' ),
          datasets: [{
            label: 'Reações',
            data: this.results.reacoes.map(row => row.qtde),
            backgroundColor: [
              'rgba(255, 99, 132, 0.2)',
              'rgba(255, 205, 86, 0.2)',
              'rgba(75, 192, 192, 0.2)',
              'rgba(54, 162, 235, 0.2)',
              'rgba(153, 102, 255, 0.2)',
              'rgba(201, 203, 207, 0.2)',
            ],

          }],
        },
      },
      form: {
        dtProspeccao: this.filters.dtProspeccao,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: debounce(function() {
        this.$inertia.get(this.route('dashboard'), pickBy(this.form))
      }, 500),
    },
  },
  methods: {
    dtProspeccao(model){
      return DateTime.fromSQL(model.dtProspeccao).toFormat('dd/MM/yyyy')
    },
    dtVisita(model){
      return DateTime.fromSQL(model.dtProximaVisita).toFormat('dd/MM/yyyy')
    },
    abrevia(str) {
      let nome = str.replace(/\s+/gi, ' ').trim()
      nome = nome.replace(/[0-9]/g, '').replace('(', '').replace(')', '').replace('-', '')
      var array_nome = nome.split(' ')
      if(array_nome.length > 2){
        return array_nome.map((parte, index) => (index != 1) ? parte : `${parte[0]}.`).join(' ')
      }else{
        return str
      }
    },

  },
}
</script>
